module.exports = __webpack_public_path__ + "i18n/es_3f7b15c93a9ff3df64e39f006e03fff8.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/m_es.properties
// module id = DOE4
// module chunks = 118